'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Modal } from '@repo/design-system/components/ui/modal';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
interface FogResetConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
export const FogResetConfirmModal = t0 => {
  const $ = _c(32);
  const {
    isOpen,
    onConfirm,
    onCancel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onCancel) {
    t3 = details => {
      if (!details.open) {
        onCancel();
      }
    };
    $[3] = onCancel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Type variant="body-s" color="white">{t4}</Type>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = css({
      flex: "1"
    });
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp3);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onConfirm || $[13] !== t7) {
    t8 = <Button onClick={onConfirm} color="warning" size="lg" className={t6}>{t7}</Button>;
    $[12] = onConfirm;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = css({
      flex: "1"
    });
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t(_temp4);
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== onCancel || $[19] !== t10) {
    t11 = <Button onClick={onCancel} color="secondary" size="lg" className={t9}>{t10}</Button>;
    $[18] = onCancel;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t8) {
    t12 = <FlexRow gap="8" justify="end" width="full">{t8}{t11}</FlexRow>;
    $[21] = t11;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t5) {
    t13 = <FlexColumn gap="12">{t5}{t12}</FlexColumn>;
    $[24] = t12;
    $[25] = t5;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isOpen || $[28] !== t13 || $[29] !== t2 || $[30] !== t3) {
    t14 = <Modal title={t2} isOpen={isOpen} onOpenChange={t3} size="sm" hideCloseButton={true}>{t13}</Modal>;
    $[27] = isOpen;
    $[28] = t13;
    $[29] = t2;
    $[30] = t3;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};
function _temp($) {
  return $.fog_reset_modal.title;
}
function _temp2($_0) {
  return $_0.fog_reset_modal.description;
}
function _temp3($_1) {
  return $_1.yes_reset;
}
function _temp4($_2) {
  return $_2.cancel;
}